<div class="breadCrumb">
	<a (click)="goTo(item)" *ngFor="let item of fastNavigationData">{{item.name}}</a>
</div>
